import React from "react";
import PropTypes from "prop-types";
import { TextInput } from "@narmi/design_system";
import ContextForm from "../ContextForm";

// Default error messages
const DEFAULT_EMAIL_ERROR = "Please enter a valid email address.";
const DEFAULT_MAX_LENGTH_ERROR = "Exceeds character limits";

// Standalone email validation function for external use
export function validateEmail(value, disabled, errorMsg, maxLength, maxLengthErrorMsg) {
  if (disabled) return null;
  if (!value) return errorMsg;

  // Check maxLength first if provided
  if (maxLength && value.length > maxLength) {
    return maxLengthErrorMsg;
  }

  // at least one character that's not a space or @ before the @
  // at least one character that's not a space or @ after the @, followed by a dot
  // at least one character that's not a space or @ after the dot
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Ensure email has no whitespace
  if (/\s/.test(value)) {
    return errorMsg;
  }

  if (!emailRegex.test(value)) {
    return errorMsg;
  }

  return null;
}

const EmailFormField = ({
  label,
  required = false,
  disabled,
  fieldStyle,
  className,
  errorLabel = DEFAULT_EMAIL_ERROR,
  maxLength,
}) => {
  return (
    <ContextForm.Field
      required={required}
      validate={(value) =>
        validateEmail(value, disabled, errorLabel, maxLength, DEFAULT_MAX_LENGTH_ERROR)
      }
      style={fieldStyle}
      className={className}
    >
      <TextInput
        name="email"
        field="email"
        label={label || "Email"}
        type="email"
        data-test-element="email-input"
        disabled={disabled}
        maxLength={maxLength}
      />
    </ContextForm.Field>
  );
};
EmailFormField.propTypes = {
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  fieldStyle: PropTypes.object,
  className: PropTypes.string,
  errorLabel: PropTypes.string,
  maxLength: PropTypes.number,
};
export default EmailFormField;
